<div class="subregions" [attr.data-region]="region._meta.id">
  <div class="lbl">Sub-regions of {{ region.name || 'this region' }}</div>
  <ul class="plain">
    <li *ngFor="let sr of subRegions; let i = index" class="subregion-row" [attr.data-subregion]="sr.id">
      <div class="flex align-items-center gap-2">
        <button type="button" class="swatch-btn" [disabled]="busy" (click)="colourFor = colourFor === sr.id ? null : sr.id" pTooltip="Its colour on the map"
                [attr.aria-label]="'Colour of ' + sr.name">
          <span class="swatch ring" [style.border-color]="'var(--app-subregion-' + slot(sr, i) + ')'"></span>
        </button>
        <span class="flex-1 min-w-0 truncate">
          {{ sr.name }}
          <span class="text-500 text-xs members">{{ sr.members | number }} suburb{{ sr.members === 1 ? '' : 's' }}{{ sr.published ? '' : ' · unpublished' }}</span>
        </span>
        <button pButton type="button" icon="pi pi-map" class="p-button-text p-button-rounded p-button-sm sr-map" (click)="openOnMap(sr)"
                pTooltip="Its suburbs, on the Suburbs map"></button>
        <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-sm sr-edit" (click)="editPage(sr)" pTooltip="Edit its page"></button>
        <span [pTooltip]="deleteBlock(sr) || 'Delete'" tooltipPosition="left">
          <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-sm p-button-danger sr-delete"
                  [disabled]="busy || !!deleteBlock(sr)" (click)="delete(sr)"></button>
        </span>
      </div>
      <div app-suburb-colour-picker *ngIf="colourFor === sr.id" class="colour-picker" [selected]="slot(sr, i)" (pick)="pickColour(sr, $event)"></div>
    </li>
  </ul>
  <div *ngIf="!subRegions.length" class="text-600 text-sm">None yet.</div>
  <button pButton type="button" class="p-button-text p-button-sm new-subregion" icon="pi pi-plus" label="New sub-region" (click)="newSubRegion()"></button>
  <div class="meta">A sub-region's page and its suburbs are edited in the Suburbs tool, which opens over this window.</div>
</div>
